import type { CustomizationProjectListColumnKey } from "../types";

export const CUSTOMIZATION_PROJECT_LIST_VISIBLE_COLUMNS_STORAGE_KEY =
  "customization.project_list.visible_columns.v1";

export const customizationProjectListColumnOptions: Array<{
  key: CustomizationProjectListColumnKey;
  label: string;
  required?: boolean;
}> = [
  { key: "formed", label: "团" },
  { key: "name", label: "定制名称", required: true },
  { key: "customerSource", label: "客户来源" },
  { key: "sales", label: "销售" },
  { key: "dispatcher", label: "计调" },
  { key: "signType", label: "签单类型" },
  { key: "version", label: "当前版本" },
  { key: "latestItinerary", label: "最近行程" },
  { key: "demandVersionCount", label: "需求版本数" },
  { key: "itineraryCount", label: "行程数" },
  { key: "projectCreatedAt", label: "项目创建时间" },
  { key: "versionUpdatedAt", label: "版本更新时间" },
  { key: "destinations", label: "目的地" },
  { key: "travelerCount", label: "人数" },
];

export const customizationProjectListDefaultVisibleColumns: CustomizationProjectListColumnKey[] =
  customizationProjectListColumnOptions.map((item) => item.key);

/** 列 key 与表格列宽映射，供 scroll.x 与顶部滚动条同步。 */
export const customizationProjectListColumnWidths: Record<
  CustomizationProjectListColumnKey,
  number
> = {
  formed: 64,
  name: 280,
  customerSource: 250,
  sales: 120,
  dispatcher: 120,
  signType: 120,
  version: 130,
  latestItinerary: 156,
  demandVersionCount: 120,
  itineraryCount: 100,
  projectCreatedAt: 156,
  versionUpdatedAt: 156,
  destinations: 180,
  travelerCount: 100,
};
